//TODO: Look into reorganizing structure for storing types/interfaces

import { MenuItem } from "primeng/api"
import { StaffRoles } from "../auth/tokens"
import { TripType } from "../ui/dropdowns/dropdown-option.service"
import { DynamicFormField, Link } from "../ui/dynamic-form/dynamicFormTypes"
import { SearchSettingsType } from "./caching/mc-search-settings.service"
import { Contact } from "./types"

export type ContactCardFragment = "info" | "staffing" | "partnership" | "consulting" | "participants" | "payments" | "flights" | "ministries" | "docs" | "shirts" | "roomingLists" | "surveys"

export type LoopbackValidationError = {
  error: {
    statusCode: number,
    code: "VALIDATION_FAILED",
    name: string,
    message: string,
    details: {

      path: string,
      message: string,
      code: string,
      info: any
    }[]
  }
}

export interface McSettings {
  id: number,
  staffId?: number,
  name: string,
  value: string
}

export interface McSearchSettings {
  uuid: string,
  type: SearchSettingsType,
  staffId: number,
  name: string,
  jsonValue: { [prop: string]: any } | null,
  value: string | null
}

export enum BackgroundCheckTypes {
  None = 0,
  SelfManaged = 1,
  Sterling = 2,
  Waived = 3,
  Mixed = 4
}

export enum SterlingStatuses {
  InProgress = "InProgress",
  New = "New",
  Complete = "Complete",
  Adjudicated = "Adjudicated"
}

export enum SterlingResults {
  Eligible = "Eligible",
  Ineligible = "Ineligible"
}

export interface CustomerBackgroundProvider {
  id: number,
  customerId: number,
  name: string,
  phone: string,
  website: string
}


export interface TripDesignation {
  id: number,
  name: string
}

export interface ParticipantMessage {
  text: string
}
export interface UiSafeStaff {
  id: number,
  first: string,
  middle: string,
  last: string,
  nickname: string,
  email: string,
  phone1: string,
  city: string,
  state: string,
  country?: string,
  apptURL: string,
  driverNotes: string,
  title: string,
  active: number,
  roles: StaffRoles[],
  kpiRoleId?: number,
  reviewSupervisorId?: number | null,
  driverNotSet?: boolean,
  driverVanNotSet?: boolean,
  alwaysShowOnStaffing: number,
  supervisor?: number,
  bambooId?: string | null,
  restricted: number,

}

export interface StaffContacts {
  id: number,
  staffId: number,
  firstName: string,
  lastName: string,
  phone1: string,
  relation: string,
  timestamp: Date,
  active: number
}

export interface BambooEmergencyContact {
  id: string
  employeeId: string
  name: string | null
  relationship: string | null
  homePhone: string | null
  addressLine1: string | null
  addressLine2: string | null
  mobilePhone: string | null
  email: string | null
  zipcode: string | null
  city: string | null
  state: string | null
  country: string | null
  workPhone: string | null
  workPhoneExtension: string | null
  primaryContact: string | null
}
export interface MinimalStaff {
  id: number,
  first: string,
  last: string
}

export interface UiSafeStaffUpdate {
  alwaysShowOnStaffing?: number,
  email?: string,
  address1?: string,
  address2?: string,
  city?: string,
  state?: string,
  zip?: string,
  country?: string,
  phone1?: string,
  reviewSupervisorId?: number | null,
  kpiRoleId?: number,
  workingFrom?: string,
  title?: string,
  first?: string,
  last?: string,
  apptURL?: string,
  driver?: number,
  driverVan?: number,
  driverNotes?: string
  restricted?: number | null,
}

export interface SeasonalStaffDetail {
  id: number,
  staffId: number,
  location: string,
  notes: string,
  flex: number,
  primaryOpsRegionId?: number | null
}

export enum CustomerGroupType {
  Church = 1,
  Organization = 2,
  Foundation = 3,
  Corporation = 4,
  Individual = 5,
}

export type CustomerGroupTypeString = keyof typeof CustomerGroupType;

export enum FundraisingStatus {
  Not_Set = 0,
  Prospect = 1,
  New_Donor = 2,
  Active_Donor = 3,
  Lapsed_Donor = 4,
  Recurring_Donor = 5
}

export interface Customer {
  id: number,
  groupname: string,
  leader?: string,
  timestamp: Date,
  shippingaddress?: string,
  billingaddress?: string,
  dayphone?: string,
  churchphone?: string,
  email?: string,
  passwd?: string,
  position?: string,
  leadtype?: string,
  address1?: string,
  address2?: string,
  attn?: string,
  city?: string,
  stateprov?: string,
  zipcode?: string,
  country?: string,
  shipaddress1?: string,
  shipaddress2?: string,
  shipattn?: string,
  shipcity?: string,
  shipstateprov?: string,
  shipzipcode?: string,
  shipcountry?: string,
  renewalnote?: string,
  renewaltimestamp: Date,
  renewalstatus?: number,
  lat?: number,
  lng?: number,
  fax?: string,
  tyg?: number,
  fmsc?: string,
  visiontrip?: string,
  denomination?: string,
  leadsource?: string,
  website?: string,
  status?: number,
  pastteam?: string,
  recruiterId?: number,
  individual?: string,
  countryinterest?: number,
  recruiter?: string,
  assistId?: number,
  customerstatus?: string,
  mailinglist?: number,
  recruitingQuickNote?: string,
  recruitingNoteTimestamp?: Date,
  recruitingNoteStaffId?: number,
  imported?: number,
  fundraisingStatus: number,
  donorRecruiterId?: number,
  marketingDetails?: CustomerMarketingDetails,
  tags?: CustomerTags
  groupType: CustomerGroupType,
  tripsEnabled: number

}


export const CustomerQuickNotesKeys = ['giftNotes', 'giftImpact', 'generalFundraising'] as const;
export type CustomerQuickNotesKey = (typeof CustomerQuickNotesKeys)[number];

export interface CustomerQuickNote {
  id: number,
  customerId: number,
  key: CustomerQuickNotesKey,
  data: string,
  lastUpdated: Date,
  lastUpdatedBy: number
}



export enum CustomerDonationSourceType {
  Stripe_CC = 1,
  Stripe_Bank = 2,
  Paypal = 3,
  Check = 4
}

export interface CustomerDonation {
  id: number,
  customerId: number,
  stripeLogId: number | null,
  paypalLogId: number | null,
  amount: number,
  donationDate: Date,
  createdDate: Date,
  sourceType: CustomerDonationSourceType,
  notes: string,
  netsuiteProgramId?: number
}

export interface CustomerMarketingDetails {
  id: number,
  custId: number,
  referral: string
}

export interface CustomerTags {
  id: number,
  name: string,
  active: number
}

export enum PotentialGiftStatus {
  Identification = 1,
  Cultivation = 2,
  Proposal_Submitted = 3,
  Pending = 4,
  Committed_Verbal = 5,
  Committed_Written = 6,
  Received = 7,
  Declined = 8,
  Deferred = 9

}



export enum PotentialGiftFrequency {
  Recurring = 1,
  One_Time = 2
}

export interface PotentialGift {
  id: number,
  customerId: number,
  fundraiserId: number,
  netsuiteProgramId: number,
  status: PotentialGiftStatus,
  frequency: PotentialGiftFrequency,
  anticipatedGivingDate: Date,
  amount: number,
  hurdles: string,
  quicknote: string,
  closed: number,
  contacts?: Contact[]
}

export interface PotentialGiftWithContacts extends PotentialGift {
  contacts: Contact[]
}

export interface PotentialGiftContact {
  id: number,
  potentialGiftId: number,
  contactId: number
}

export interface NetsuiteProgram {
  id: number,
  name: string,
  active: number
}


export interface NewLead {
  assignedOn?: Date;
  campaign?: string;
  comments?: string;
  content?: string;
  custId?: number;
  email?: string;
  id: number;
  location?: string;
  medium?: string;
  name?: string;
  numVisits?: number;
  officeID?: number;
  org?: string;
  phone?: string;
  recruiterID?: number;
  size?: string;
  source?: string;
  term?: string;
  timestamp?: Date;
  transferred?: number;
  type?: string;
  securityScore?: number;
  active?: number;
}

export enum MarketingDetailReferral {
  Empty = "empty",
  GlobalLeadershipSummit = "gls",
  YouthPastor = "youthPastor",
  GoogleSearch = "googleSearch",
  OtherOrg = "otherOrg",
  Marko = "marko"

}

export interface OnTimePaymentIncentive {
  tripId: number,
  expiresOn: Date,
  amount: number,
  custId: number
}


export interface PotentialGl {
  id: number,
  email: string,
  name: string,
  type: "pastGl" | "contact"
}

export interface GlInfo {
  newuserId: number,
  email: string,
  firstname: string,
  lastname: string
}

export interface CustomerServiceQualifyingTrip {
  id: number,
  label: string,
  tripDate: Date,
}

export interface CustomerServiceRecipient extends GlInfo {
  trips: CustomerServiceQualifyingTrip[],
}

export interface Trip {
  id: number,
  officeId: number,
  tripDate: Date,
  tripEndDate: Date,
  destination?: string,
  duration: number,
  accommodations?: string,
  cost: number,
  consult?: string,
  custId: number,
  dateReserved: Date,
  /**
   * The trip leader
   */
  staffId?: number,
  siteLeaderId?: number,
  siteLeaderConfirmed?: number,
  /**
   * Recruiter who gets credit for the trip
   */
  salesId?: number,
  attendees: number,
  attendeesOriginal: number,
  guestUser: string,
  grouping?: string,
  lodging?: string,
  /**
   * Recreation Lodging
   */
  anchorage?: string,
  /**
   * Recreation
   */
  caye?: string,
  /**
   * Transportation
   */
  bus?: string,
  newReg: number,
  cbWelcomeCall: number,
  cbPromo: number,
  cbTshirts: number,
  cbCustForms: number,
  cbFlightInfo: number,
  cbGoodToGo: number,
  cbLiabilityForm: number,
  individual: number,
  showTj: number,
  airport: string,
  minMoneyEst: number,
  ministryMoney: number,
  mmLock: number,
  quickNote?: string,
  vehicle?: string,
  meals?: string,
  expenses?: string,
  itinerary?: string,
  itineraryPub: number,
  special: number,
  cbPack: number,
  translator?: string,
  terms?: number,
  fmsc: number,
  ppm?: number,
  consultPub?: number,
  tlPub?: number,
  salesAssist?: number,
  promo?: string,
  consultId?: number,
  active: number,
  cutoff: number,
  dropped: number,
  dropReason?: string
  noInvoice: number,
  yc: number,
  driving: number,
  translatorConfirmed?: number,
  lodgingConfirmed?: number,
  /**
   * Recreation confirmed
   */
  cayeConfirmed?: number,
  /**
   * Recreation Lodging Confirmed
   */
  anchorageConfirmed?: number,
  /**
   * Transportation confirmed
   */
  busConfirmed?: number,
  vehicleConformed?: number,
  mealsConfirmed?: number,
  groupingConfirmed?: number,
  airportConfirmed?: number,
  partPay?: number,
  tripDonate?: number,
  travelPay: number,
  partDonate: number,
  partDonatePublic: number,
  adminConsult: number,
  locId: string,
  subtrips: number,
  recommendedJournal: number,
  displayAfterCutoff: number,
  consultantNote?: string,
  timestamp: Date,
  lastInvoiced?: Date,
  lastAttendeeChange?: Date,
  extendDonation: number,
  renewal: number,
  glJournals: number,
  consultingEmails: number,
  leaderTrip: number,
  leaderMission?: number,
  leaderSponsor?: number,
  termsConditionsUrl?: string,
  termsConditionsTimestamp?: Date,
  termsConditionsUserId?: number,
  covidPaymentAgreementUrl?: string,
  covidPaymentAgreementTimestamp?: string,
  covidPaymentAgreementUserId?: number,
  fundraisingAgreementUrl?: string,
  fundraisingAgreementTimestamp?: Date,
  shirtsNote?: string,
  shirtOrderNum?: string,
  guideOrderNum?: string,
  disaster: number,
  transferredTripId?: number,
  inAbacus: number,
  hasGroupPhoto: number,
  hasGroupThumbnail: number,
  /**
   * This field is generated locally and aggregates the fmsc,special,leaderTrip,leaderMission,leaderSponsor,and disaster fields into one value.
   */
  tripType: TripType
  designation: number,
  backgroundCheckType: BackgroundCheckTypes,
  locationChanges?: TripLocationChangeHistory[],
  quicknoteStaffId?: number,
  quicknoteTimestamp?: Date,
  waiveRegiFee: number,
  alternatePaymentSchedule?: string | null
}

export enum DropReasons {
  Finances = "Finances",
  GL_Change = "GL Change",
  Location = "Location",
  Timing = "Timing",
  Not_Ready = "Weren't ready to register",
  No_Communication = "No communication from consultant",
  Another_Org = "Going with another org",
  Recruiting = "Team recruiting issues",
  Advisory = "Travel/health advisory",
  No_GL_Communication = "No communication from GL",
  Emergency = "Emergency situation"


}

export interface TripDocument {
  id: number,
  tripId: number,
  staffId: number,
  glOnly: number,
  driveLink: number,
  fileName: string,
  uploadDate: Date,
  note: string,
  driveId: string,
  documentLink: string
}



export interface TripDetail extends Pick<Trip, "id" | "custId" | "tripDate" | "tripEndDate" | "dateReserved" | "duration" | "attendees" | "attendeesOriginal" | "ppm" | "fmsc" | "dropped" | "active" | "minMoneyEst" | "showTj" | "hasGroupPhoto" | "designation"> {


  type: number,
  consultingEmails: number,
  location: string,
  groupName?: string,
  glName: string,
  glFirstName: string,
  glLastName: string,
  glEmail: string,
  domestic: number,
  restricted?: number,
  subtrips: number,
  minMoneyEst: number,
  ministryMoney: number,
  tripYear: string,
  consultantName: string,
  consultantEmail: string,
  consultantId: number,
  tlName: string,
  tlEmail: string,
  tlId: number,
  siteLeaderName?: string,
  siteLeaderEmail?: string,
  siteLeaderId?: number,
  recruiterName: string,
  recruiterEmail: string,
  recruiterId: number,
  assistName?: string,
  assistEmail?: string,
  assistId?: number,
  subtripId: string,
  subtripIds: string[]
}

export interface TripLocationChangeHistory {
  id: number,
  tripId: number,
  prevLocID: string,
  nextLocID: string,
  timestamp: Date
}

export interface TripsSub {
  id: string,
  subtripName: string,
  tripId: number,
  itineraryUrl: string,
  itineraryPublic: number,
  //NOTE: These properties are sourced from the trip
  // tlId: number,
  // tlConfirmed: number,
  // tlPublic: number,
  lodging: string,
  recreation: string
  recLodging: string,
  transportation: string,
  vehicle: string,
  meals: string,
  translator: string,
  lodgingConfirmed: number,
  recreationConfirmed: number,
  recLodgingConfirmed: number,
  transportationConfirmed: number,
  vehicleConfirmed: number,
  mealsConfirmed: number,
  translatorConfirmed: number,
  tlLocalOverride: number,
  atl1: number,
  atl1Confirmed: number,
  atl1LocalOverride: number,
  atl2: number,
  atl2Confirmed: number,
  atl2LocalOverride: number,
  atl3: number,
  atl3Confirmed: number,
  atl3LocalOverride: number,
  atl4: number,
  atl4Confirmed: number,
  atl4LocalOverride: number,
  atl5: number,
  atl5Confirmed: number,
  atl5LocalOverride: number,
  atl6: number,
  atl6Confirmed: number,
  atl6LocalOverride: number,
  atl7: number,
  atl7Confirmed: number,
  atl7LocalOverride: number,
  atl8: number,
  atl8Confirmed: number,
  atl8LocalOverride: number,
  atl9: number,
  atl9Confirmed: number,
  atl9LocalOverride: number,
  atl10: number,
  atl10Confirmed: number,
  atl10LocalOverride: number,
  atl11: number,
  atl11Confirmed: number,
  atl11LocalOverride: number,
  atl12: number,
  atl12Confirmed: number,
  atl12LocalOverride: number,
  atl13: number,
  atl13Confirmed: number,
  atl13LocalOverride: number,
  atl14: number,
  atl14Confirmed: number,
  atl14LocalOverride: number,
  atl15: number,
  atl15Confirmed: number,
  atl15LocalOverride: number,
  atl16: number,
  atl16Confirmed: number,
  atl16LocalOverride: number,
  timestamp: Date
}

export type StaffFieldPrefix = 'tl' | `atl${1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16}`;
export type AtlFieldKey = `atl${1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16}`;
export type LocalOverrideNotesKey = `${StaffFieldPrefix}LocalOverride`;

export interface TripsSubNotes {
  id: number,
  subtripId: string,
  field: string,
  notes: string
}

export interface TripQuickNote {
  id: number,
  tripId: number,
  note: string,
  lastUpdatedStaffId?: number,
  lastUpdatedDate: Date
}

export interface ConsultingTemplate {
  id: number,
  name: string,
  sections: ConsultingCallSection[],
  active: boolean,
  tripYear: number,
  startDate: Date,
  completeByUnit: string,
  completeByValue: number,
  completeByFrom: keyof Pick<Trip, 'tripDate' | 'dateReserved'>,
  alwaysEditable: number,
  callType: string
}



export interface ConsultingCallSection {
  sectionName: string,
  topics: ConsultingTemplateTopic[]
  conversationStarters: ConsultingConversationStarter[],
  hideName: boolean
}
export interface ConsultingTemplateTopic extends DynamicFormField {
  name: string,
  text: string,
  link?: Link,
  id: string,
  order: number,
  indent: number,
  verticalPadding?: number
}

export interface ConsultingTemplateNote {
  id: string
}

export interface ConsultingConversationStarter {
  id: string,
  text: string,
  appendComponent: string,
  appendComponentInputs: any
}

export interface ConsultingCall {
  id: number
  tripId: number,
  consultingTemplateId: number,
  topics: ConsultingCallTopic[],
  // notes: ConsultingCallNote[],
  percentComplete: number,
  isComplete: number,
  completedByStaffId: number,
  dateComplete: Date
}


export interface ConsultingCallTopic extends ConsultingTemplateTopic {
  value: any
}

export interface ConsultingCallNote extends ConsultingTemplateNote {
  notes: string
}

export interface PromoCodes {
  id: number,
  active: number,
  name: string,
  description: string,
  discountAmount?: number,
  maxDiscountAmount?: number,
  perPerson?: number,
  perPersonCount?: number,
  requiredTeamSize?: number,
  tripCostDiscounted?: number,
  numberTripsDiscounted?: number,
  maxTripCostDiscount?: number,
  promoStart?: Date | null,
  promoEnd?: Date | null,
  tripStart?: Date | null,
  tripEnd?: Date | null,
  postTripWindow?: number,
  isPercentage?: number,
  percentage?: number | null
}



export enum LogTypes {
  system = 0,
  note = 1,
  message = 2,
  toCustomer = 3,
  call = 4,
  emailOrText = 5,
  task = 6,
  meeting = 7
}

export enum CallResults {
  none = 0,
  successfulCall = 1,
  leftVoicemail = 2,
  attemptedCall = 3
}

export enum Categories {
  none = 0,
  consulting = 1,
  recruiting = 2,
  finance = 3,
  other = 4,
  travel = 5,
  fundraising = 6,
  donorEngagement = 7
}

export enum PartnerLogType {
  note = 1,
  task = 6,
  meeting = 7,
  email = 5,
  call = 4,
}

export enum NotePriorities {
  None = 0,
  Low = 1,
  Normal = 2,
  High = 3
}

export enum NoteReminderTypes {
  Email = 'email',
  Slack = 'slack'
}


//Maps to CustomerLog on the API side
export interface Note {
  id: number,
  custId: number,
  staffId?: number,
  notes: string,
  submitted: Date,
  timestamp: Date,
  logType: LogTypes,
  flagged: number,
  addressed: number,
  tripId?: number,
  category: Categories,
  callResult: CallResults,
  dateScheduled: Date,
  dateCompleted?: Date,
  priority: NotePriorities,
  completed: number,
  inactive: number,
  leaderId?: number,
  assignId: number,
  ns: number,
  contactId: number,
  reminderTime?: Date,
  reminderType?: string | null,
  tagged?: string,
  restrictionLevel?: number,
}

export interface PartnerLog {
  id: number;
  partnerId: string;
  staffId: number;
  notes: string;
  submitted: Date;
  timestamp: Date;
  logtype: number;
  flagged: number;
  addressed: number;
  tripId: number;
  category: number;
  callresult?: number;
  datescheduled: Date;
  datecompleted: Date;
  priority: number;
  completed: number;
  inactive: number;
  assignId: number;
  ns: number;
  contactId: string;
  reminderTime?: Date;
  reminderType?: string;
  tagged?: string;
}

export interface ParticipantSnapshotData {
  attendees: number,
  rosterCount: number,
  covidAgreement: boolean,
  formsCount: number,
  legalCount: number,
  covidAgreeCount: number,
  shirtCount: number,
  backgroundCheckCount?: number,
  backgroundCheckAttendees?: number
}

export interface Flight {
  id: number,
  tripId: number,
  direction: FlightDirections,
  flightline: string,
  flightnum: string,
  flightfromport: string,
  flightfromdate: Date,
  flightfromtime: string,
  flighttoport: string,
  flighttodate: Date,
  flighttotime: string,
  userId: string | null,
  size: number,
  pt: number,
  ptQuoteId: number | null,
  ptFlightId: number | null
}

export enum FlightDirections {
  To = 0,
  From = 1

}

/* export enum PartnerType {
  None = "",
  Church_or_Ministry = "Church/Ministry",
  Recreation = "Recreation",
  Clinic = "Clinic",
  Retail = "Retail",
  School = "School",
  Mercy = "Mercy",
  Restaurant = "Restaurant",
  Transportation = "Transportation",
  Hotel_or_Lodging = "Hotel/Lodging"
} */

export type MinistryType =
  "children" |
  "service" |
  "church" |
  "sports" |
  "prayer" |
  "school" |
  "mercy" |
  "evangelism" |
  "youth" |
  "adult" |
  "medical" |
  "other"

export interface TripMinistry {
  type: MinistryType
  description: string
  checked: true
}

export interface GetTimeZoneResponse {

  zoneName: string | null;
  
}


export interface ConsultGl {
  tripId: number,
  recruiting?: string,
  recruitingStaff?: string,
  demographic?: string,
  fundPayment?: string,
  fundPaymentStaff?: string,
  minMoney?: 'Other' | 'Unsure' | 'More Info' | number | null,
  minMoneyNote?: string,
  minMoneyStaff?: string,
  missionHistory?: string,
  goals?: string,
  goalsStaff?: string,
  ministryNot?: string,
  teamSkills?: string,
  teamSkillsStaff?: string,
  longTerm?: string,
  longTermStaff?: string,
  toKnow?: string,
  toKnowStaff?: string,
  pray?: string
}

export type FlagIcon = ":flag-us:" | ":flag-cr:"
export type OfficeShortCode = "us" | "cr"
export interface PpmOffice {
  id: number,
  name: string,
  active: number,
  flagIcon: FlagIcon,
  shortcode: OfficeShortCode

}

export interface ShirtDetails {
  firstName: string,
  lastName: string,
  shirtSize: string
}

export const ShirtSizes = {
  "1": "Small",
  "2": "Medium",
  "3": "Large",
  "4": "XL",
  "5": "2XL",
  "6": "3XL",
  "7": "4XL"
} as const

export interface MenuCommandEvent {
  event: any,
  item: MenuItem
}

export interface Ptrip {
  id: number,
  recruiterId: number,
  assistId: number,
  custId: number,
  contactId: number,
  tripStart: Date,
  tripEnd: Date,
  regStart: Date,
  regEnd: Date,
  status: number,
  attendees: number,
  cost: number,
  hurdles: string,
  inactive: number,
  closed: number,
  location1: string,
  location2: string,
  location3: string,
  location4: string,
  location5: string,
  renewal: number,
  quickNote: string
  duration: number
}

export enum PtripStatuses {
  Did_Not_Register = 0,
  Planning_Trip = 30,
  PPM_is_an_Option = 50,
  Verbally_Committed = 75,
  Registered = 100
}

export interface LatLng {
  lat: number,
  lng: number
}

export interface TextMessage {
  id: number,
  messageText: string,
  sendDate: Date,
  staffId: number,
  messageService: MessageServiceEnum
}

export enum MessageServiceEnum {
  Marketing = "marketing"
}

export interface LocationRegions {
  name: string
}

export interface Alerts {
  id?: number,
  staffID?: number,
  type?: number,
  timestamp?: string,
  note?: string,
  subject?: string,
  expire?: string
}

export interface GlParticipantSurvey {
  glLocationSummary: GLLocationSummary[];
  glStaffSummary: GLStaffSummary[];
  glRoleSummary: GLRoleSummary[];
  glDomesticInternationalSummary: GLDomesticInternationalSummary[];
  glVmiSummary: GLVMISummary[];
  glOverallSummary: GLOverallSummary[];
  participantLocationSummary: ParticipantLocationSummary[];
  participantTlSummary: ParticipantTLSummary[];
  participantRoleSummary: ParticipantRoleSummary[];
  participantDomesticInternationalSummary: ParticipantDomesticInternationalSummary[];
  participantVmiSummary: ParticipantVMISummary[];
  participantOverallSummary: ParticipantOverallSummary[];
  combinedLocationSummary: CombinedLocationSummary[];
  combinedTlSummary: CombinedTLSummary[];
  combinedRoleSummary: CombinedRoleSummary[];
  combinedDomesticInternationalSummary: CombinedDomesticInternationalSummary[];
  combinedVmiSummary: CombinedVMISummary[];
  combinedOverallSummary: CombinedOverallSummary[];
  glSurveys: GlSurvey[];
  participantSurveys: ParticipantSurvey[];
}

export interface GLLocationSummary {
  destinationName: string;
  surveyCount: number;
  overall: number;
  registration: number;
  account: number;
  pretrip: number;
  resources: number;
  staffName: string;
  partner: number;
  culture: number;
  staff: number;
  ministry: number;
  meals: number;
  lodging: number;
  trans: number;
  recreation: number;
  registrationExperience: number;
  tripleader: number;
  revisit: number;
}

export interface GLStaffSummary {
  tripLeaderName: string;
  surveyCount: number;
  overall: number;
  registration: number;
  account: number;
  pretrip: number;
  resources: number;
  partner: number;
  culture: number;
  staff: number;
  ministry: number;
  meals: number;
  lodging: number;
  trans: number;
  recreation: number;
  registrationExperience: number;
  tripleader: number;
  revisit: number;
}

export interface GLRoleSummary {
  summary: number;
  surveyCount: number;
  overall: number;
  registration: number;
  account: number;
  pretrip: number;
  resources: number;
  partner: number;
  culture: number;
  staff: number;
  ministry: number;
  meals: number;
  lodging: number;
  trans: number;
  recreation: number;
  registrationExperience: number;
  tripleader: number;
  revisit: number;
}

export interface GLDomesticInternationalSummary {
  summary: number;
  surveyCount: number;
  overall: number;
  registration: number;
  account: number;
  pretrip: number;
  resources: number;
  partner: number;
  culture: number;
  staff: number;
  ministry: number;
  meals: number;
  lodging: number;
  trans: number;
  recreation: number;
  registrationExperience: number;
  tripleader: number;
  revisit: number;
}

export interface GLVMISummary {
  summary: number;
  surveyCount: number;
  overall: number;
  registration: number;
  account: number;
  pretrip: number;
  resources: number;
  partner: number;
  culture: number;
  staff: number;
  ministry: number;
  meals: number;
  lodging: number;
  trans: number;
  recreation: number;
  registrationExperience: number;
  tripleader: number;
  revisit: number;
}

export interface GLOverallSummary {
  summary: number;
  surveyCount: number;
  overall: number;
  registration: number;
  account: number;
  pretrip: number;
  resources: number;
  partner: number;
  culture: number;
  staff: number;
  ministry: number;
  meals: number;
  lodging: number;
  trans: number;
  recreation: number;
  registrationExperience: number;
  tripleader: number;
  revisit: number;
}

export interface ParticipantLocationSummary {
  locationName: string;
  surveyCount: number;
  overall: number;
}

export interface ParticipantTLSummary {
  tlName: string;
  surveyCount: number;
  overall: number;
}

export interface ParticipantTLData {
  summary: string;
  surveyCount: number;
  overall: number;
}

export interface ParticipantRoleSummary {
  summary: number;
  surveyCount: number;
  overall: number;
}

export interface ParticipantDomesticInternationalSummary {
  summary: number;
  surveyCount: number;
  overall: number;
}

export interface ParticipantVMISummary {
  summary: number;
  surveyCount: number;
  overall: number;
}

export interface ParticipantOverallSummary {
  summary: number;
  surveyCount: number;
  overall: number;
}

export interface CombinedLocationSummary {
  locationName: string;
  totalCount: number;
  glCount: number;
  partCount: number;
  overall: number;
}

export interface CombinedTLSummary {
  tlName: string;
  totalCount: number;
  glCount: number;
  partCount: number;
  overall: number;
}

export interface CombinedRoleSummary {
  summary: number;
  totalCount: number;
  glCount: number;
  partCount: number;
  overall: number;
}

export interface CombinedDomesticInternationalSummary {
  summary: number;
  totalCount: number;
  glCount: number;
  partCount: number;
  overall: number;
}

export interface CombinedVMISummary {
  summary: number;
  totalCount: number;
  glCount: number;
  partCount: number;
  overall: number;
}

export interface CombinedOverallSummary {
  summary: number;
  totalCount: number;
  glCount: number;
  partCount: number;
  overall: number;
}

export interface GlSurvey {
  id: number;
  custId: number;
  tripId: number;
  staffID: number;
  newuser_id: number;
  username: string
  firstname: string;
  lastname: string;
  email: string;
  groupname: string;
  destination: string;
  destinationName: string;
  tripdate: string;
  tlName: string;
  consultantName: string | null;
  first: string;
  last: string;
  active: number;
  overall: number;
  registration: number;
  registrationExperience: number;
  account: number;
  pretrip: number;
  resources: number;
  partner: number;
  culture: number;
  staff: number;
  ministry: number;
  meals: number;
  lodging: number;
  trans: number;
  recreation: number;
  tripleader: number;
  revisitPpm: number;
  revisit: number;
  support: string;
  impact: string;
  improve: string;
  timestamp: string;
  ppm365Interest: number;
}

export interface ParticipantSurvey {
  id: number;
  tripId: number;
  newuser_id: number;
  newuserId: number;
  overall: number;
  impact: string;
  well: string;
  improve: string
  active: number;
  firstname: string;
  lastname: string;
  email: string;
  dob: Date | null;
  glName: string;
  consultantName: string | null;
  pName: string;
  staffId: number;
  custId: number;
  destinationName: string;
  tripdate: string;
  destination: string;
  groupname: string;
  timestamp: string;
  role: string;
  ppm365Interest: number;
}

export interface RecruitingTripReportRow {
  groupname: string;
  glName: string;
  location: string;
  tripdate: Date;
  attendees: number;
  cost: number;
  dateReserved: Date;
  attendees_original: number;
  recruiterName: string;
  consultantName: string;
  tlName: string;
  custId: number;
  tripID: number;
  newTrip: string;
}

export interface TripLeaderDetailsRow {
  groupname: string;
  leader: string;
  destination: string;
  tripdate: Date;
  attendees: number;
  customerId: number;
}
export interface TripListRow {
  staffName: string;
  tripStartDate: Date;
  tripEndDate: Date;
  duration: number;
  staffId: number;
}

export interface TripListSummary {
  staffId: number;
  staffName: string;
  totalTrips: number;
  totalDays: number;
}
export interface NewLeadRow {
  id: number;
  timestamp: Date;
  size: number;
  name: string;
  email: string;
  phone: string;
  org: string;
  comments: string;
  location: string;
  transferred: number;
  source: string;
  page: string;
  type: string;
  assignedOn: Date;
  recruiterId: number;
  custId: number;
  first: string;
  last: string;
  recruiter: string;
}

export interface WebLeadCloseRateRow {
  id: number;
  groupName: string;
  size: string;
  leadDate: Date;
  customerId: number;
  registered: Date | null;
  customerWebleadCount: number;
  leadWeight: number;
  closeWeight: number;
}

export interface WebLeadCloseRateSummary {
  totalLeads: number;
  totalCustomers: number;
  customersRegistered: number;
  closeRateByLead: number;
  closeRateByCustomer: number;
}

export interface WebLeadCloseRateReport {
  rows: WebLeadCloseRateRow[];
  summary: WebLeadCloseRateSummary;
}

export interface PaymentReportRow {
  paymentId: number;
  tripId: number;
  amountPaid: number;
  amountPaidDate: Date;
  quicknote: string;
  paymentType: string;
  paymentCheckNumber: string;
  paymentRecievedDate: Date;
  tripdate: string;
  groupname: string;
  location: string;
  participants: number;
  cost: number;
  totalCharges: number;
  totalPaid: number;
  remainingBalance: number;
  datereserved: string;
  custID: number;
  recruiterName: string;
  consultantName: string;
  tlName: string;
}

export interface CallReportRow {
  name?: string;
  total?: number;
  successful?: number;
  message?: number;
  attempted?: number;
  unknown?: number;
}


export interface OldSurveyData {
  glLocationSummary: OldGLLocationSummary[];
  glStaffSummary: OldGLStaffSummary[];
  glRoleSummary: OldGLRoleSummary[];
  glDomesticInternationalSummary: OldGLDomesticInternationalSummary[];
  glVmiSummary: OldGLVMISummary[];
  glOverallSummary: OldGLOverallSummary[];
  partLocationSummary: OldPartLocationSummary[];
  partTlSummary: OldPartTLSummary[];
  partRoleSummary: OldPartRoleSummary[];
  partDomesticInternationalSummary: OldPartDomesticInternationalSummary[];
  partVmiSummary: OldPartVMISummary[];
  partOverallSummary: OldPartOverallSummary[];
  combinedLocationSummary: OldCombinedLocationSummary[];
  combinedTlSummary: OldCombinedTLSummary[];
  combinedRoleSummary: OldCombinedRoleSummary[];
  combinedDomesticInternationalSummary: OldCombinedDomesticInternationalSummary[];
  combinedVmiSummary: OldCombinedVMISummary[];
  combinedOverallSummary: OldCombinedOverallSummary[];
  glSurveys: OldSurveyGl[];
  partSurveys: OldPartSurvey[];
}
export interface OldSurveyGl {
  id: number;
  tripId: number;
  newuserId: number;
  expectations: number;
  prepared: number;
  logistics: number;
  needs: number;
  partner: number;
  ministry: number;
  connections: number;
  staff: number;
  meals: number;
  lodging: number;
  trans: number;
  rec: number;
  recommend: number;
  comeback: number;
  area: string;
  best: string;
  challenge: string;
  impacted: string;
  improve: string;
  statement: string;
  name1: string;
  email1: string;
  phone1: string;
  name2: string;
  email2: string;
  phone2: string;
  name3: string;
  email3: string;
  phone3: string;
  name4: string;
  email4: string;
  phone4: string;
  timestamp: Date | null;
  active: number;
  groupId: number;
  destination: string;
  firstname: string;
  lastname: string;
  email: string;
  staffFirst: string;
  staffLast: string;
  staffId: number;
  custId: number;
  destinationName: string;
  tripdate: string;
  groupname: string;
}

export interface OldPartSurvey {
  id: number;
  tripId: number;
  newuserId: number;
  impacted: string;
  best: string;
  challenge: string;
  meals: number;
  lodging: number;
  trans: number;
  ministry: number;
  rec: number;
  staff: number;
  partner: number;
  area: string;
  comeback: number;
  recommend: number;
  improve: string;
  statement: string;
  name1: string;
  email1: string;
  phone1: string;
  name2: string;
  email2: string;
  phone2: string;
  name3: string;
  email3: string;
  phone3: string;
  name4: string;
  email4: string;
  phone4: string;
  active: number;
  role: string;
  timestamp: Date | null;
  destination: string;
  tripdate: string;
  staffId: number;
  firstname: string;
  lastname: string;
  email: string;
  dob: Date | null;
  custId: number;
  groupname: string;
  first: string;
  last: string;
  destinationText: string;
}

export interface OldGLLocationSummary {
  destinationName: string;
  surveyCount: number | string | bigint;
  meals: number | string;
  prepared: number | string;
  logistics: number | string;
  expectations: number | string;
  connections: number | string;
  needs: number | string;
  lodging: number | string;
  trans: number | string;
  ministry: number | string;
  rec: number | string;
  staff: number | string;
  partner: number | string;
  comeback: number | string;
  recommend: number | string;
  overall: number | string;
}

export interface OldGLStaffSummary {
  tripLeader: string;
  surveyCount: number | string | bigint;
  meals: number | string;
  prepared: number | string;
  logistics: number | string;
  expectations: number | string;
  connections: number | string;
  needs: number | string;
  lodging: number | string;
  trans: number | string;
  ministry: number | string;
  rec: number | string;
  staff: number | string;
  partner: number | string;
  comeback: number | string;
  recommend: number | string;
  overall: number | string;
}

export interface OldGLRoleSummary {
  summary: string;
  surveyCount: number | string | bigint;
  meals: number | string;
  prepared: number | string;
  logistics: number | string;
  expectations: number | string;
  connections: number | string;
  needs: number | string;
  lodging: number | string;
  trans: number | string;
  ministry: number | string;
  rec: number | string;
  staff: number | string;
  partner: number | string;
  comeback: number | string;
  recommend: number | string;
  overall: number | string;
}

export interface OldGLDomesticInternationalSummary {
  summary: string;
  surveyCount: number | string | bigint;
  meals: number | string;
  prepared: number | string;
  logistics: number | string;
  expectations: number | string;
  connections: number | string;
  needs: number | string;
  lodging: number | string;
  trans: number | string;
  ministry: number | string;
  rec: number | string;
  staff: number | string;
  partner: number | string;
  comeback: number | string;
  recommend: number | string;
  overall: number | string;
}

export interface OldGLVMISummary {
  summary: string;
  surveyCount: number | string | bigint;
  meals: number | string;
  prepared: number | string;
  logistics: number | string;
  expectations: number | string;
  connections: number | string;
  needs: number | string;
  lodging: number | string;
  trans: number | string;
  ministry: number | string;
  rec: number | string;
  staff: number | string;
  partner: number | string;
  comeback: number | string;
  recommend: number | string;
  overall: number | string;
}

export interface OldGLOverallSummary {
  summary: string;
  surveyCount: number | string | bigint;
  meals: number | string;
  prepared: number | string;
  logistics: number | string;
  expectations: number | string;
  connections: number | string;
  needs: number | string;
  lodging: number | string;
  trans: number | string;
  ministry: number | string;
  rec: number | string;
  staff: number | string;
  partner: number | string;
  comeback: number | string;
  recommend: number | string;
  overall: number | string;
}

export interface OldPartLocationSummary {
  locationName: string;
  surveyCount: number | string | bigint;
  meals: number | string;
  lodging: number | string;
  trans: number | string;
  ministry: number | string;
  rec: number | string;
  staff: number | string;
  partner: number | string;
  comeback: number | string;
  recommend: number | string;
  overall: number | string;
}

export interface OldPartTLSummary {
  tlName: string;
  surveyCount: number | string | bigint;
  meals: number | string;
  lodging: number | string;
  trans: number | string;
  ministry: number | string;
  rec: number | string;
  staff: number | string;
  partner: number | string;
  comeback: number | string;
  recommend: number | string;
  overall: number | string;
}

export interface OldPartRoleSummary {
  summary: string;
  surveyCount: number | string | bigint;
  meals: number | string;
  lodging: number | string;
  trans: number | string;
  ministry: number | string;
  rec: number | string;
  staff: number | string;
  partner: number | string;
  comeback: number | string;
  recommend: number | string;
  overall: number | string;
}

export interface OldPartDomesticInternationalSummary {
  summary: string;
  surveyCount: number | string | bigint;
  meals: number | string;
  lodging: number | string;
  trans: number | string;
  ministry: number | string;
  rec: number | string;
  staff: number | string;
  partner: number | string;
  comeback: number | string;
  recommend: number | string;
  overall: number | string;
}

export interface OldPartVMISummary {
  summary: string;
  surveyCount: number | string | bigint;
  meals: number | string;
  lodging: number | string;
  trans: number | string;
  ministry: number | string;
  rec: number | string;
  staff: number | string;
  partner: number | string;
  comeback: number | string;
  recommend: number | string;
  overall: number | string;
}

export interface OldPartOverallSummary {
  summary: string;
  surveyCount: number | string | bigint;
  meals: number | string;
  lodging: number | string;
  trans: number | string;
  ministry: number | string;
  rec: number | string;
  staff: number | string;
  partner: number | string;
  comeback: number | string;
  recommend: number | string;
  overall: number | string;
}

export interface OldCombinedLocationSummary {
  locationName: string;
  totalCount: number | string | bigint;
  glCount: number | string | bigint;
  partCount: number | string | bigint;
  meals: number | string;
  lodging: number | string;
  trans: number | string;
  rec: number | string;
  staff: number | string;
  partner: number | string;
  comeback: number | string;
  recommend: number | string;
  prepared: number | string;
  logistics: number | string;
  expectations: number | string;
  connections: number | string;
  needs: number | string;
  ministry: number | string;
  overall: number | string;
}

export interface OldCombinedTLSummary {
  tlName: string;
  totalCount: number | string | bigint;
  glCount: number | string | bigint;
  partCount: number | string | bigint;
  meals: number | string;
  lodging: number | string;
  trans: number | string;
  rec: number | string;
  staff: number | string;
  partner: number | string;
  comeback: number | string;
  recommend: number | string;
  prepared: number | string;
  logistics: number | string;
  expectations: number | string;
  connections: number | string;
  needs: number | string;
  ministry: number | string;
  overall: number | string;
}

export interface OldCombinedRoleSummary {
  summary: string;
  totalCount: number | string | bigint;
  glCount: number | string | bigint;
  partCount: number | string | bigint;
  meals: number | string;
  lodging: number | string;
  trans: number | string;
  rec: number | string;
  staff: number | string;
  partner: number | string;
  comeback: number | string;
  recommend: number | string;
  prepared: number | string;
  logistics: number | string;
  expectations: number | string;
  connections: number | string;
  needs: number | string;
  ministry: number | string;
  overall: number | string;
}

export interface OldCombinedDomesticInternationalSummary {
  summary: string;
  totalCount: number | string | bigint;
  glCount: number | string | bigint;
  partCount: number | string | bigint;
  meals: number | string;
  lodging: number | string;
  trans: number | string;
  rec: number | string;
  staff: number | string;
  partner: number | string;
  comeback: number | string;
  recommend: number | string;
  prepared: number | string;
  logistics: number | string;
  expectations: number | string;
  connections: number | string;
  needs: number | string;
  ministry: number | string;
  overall: number | string;
}

export interface OldCombinedVMISummary {
  summary: string;
  totalCount: number | string | bigint;
  glCount: number | string | bigint;
  partCount: number | string | bigint;
  meals: number | string;
  lodging: number | string;
  trans: number | string;
  rec: number | string;
  staff: number | string;
  partner: number | string;
  comeback: number | string;
  recommend: number | string;
  prepared: number | string;
  logistics: number | string;
  expectations: number | string;
  connections: number | string;
  needs: number | string;
  ministry: number | string;
  overall: number | string;
}

export interface OldCombinedOverallSummary {
  summary: string;
  totalCount: number | string | bigint;
  glCount: number | string | bigint;
  partCount: number | string | bigint;
  meals: number | string;
  lodging: number | string;
  trans: number | string;
  rec: number | string;
  staff: number | string;
  partner: number | string;
  comeback: number | string;
  recommend: number | string;
  prepared: number | string;
  logistics: number | string;
  expectations: number | string;
  connections: number | string;
  needs: number | string;
  ministry: number | string;
  overall: number | string;
}


export interface TripLeaderStaffingDetails {
  tripId: number;
  custId: number;
  tripdate: Date;
  tripEndDate: Date;
  staffId: number;
  tl: string;
  locId: number;
  locName: string;
  region: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
}

export interface SiteLeaderDetailsRequest {
  tripId: number;
  custId: number;
  tripdate: Date;
  tripEndDate: Date;
  staffId: number;
  sl: string;
  locId: number;
  locName: string;
  region: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
}

export interface MinistryLeaderDetailsRequest {
  tripId: number;
  custId: number;
  tripdate: Date;
  tripEndDate: Date;
  staffId: number;
  ml: string;
  locId: number;
  locName: string;
  region: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
}

export interface AssistantLeaderRequest {
  tripId: number;
  custId: number;
  tripdate: Date;
  tripEndDate: Date;
  atlId: number;
  assistant: string;
  locId: number;
  locName: string;
  region: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  position: number;
}

export interface Overpayment{
    tripID: number;
    destination: string;
    tripDate: Date;
    consultantName: string;
    customerGroup: string;
    leaderName: string;
    totalCharges: number;
    totalPaid: number;
    overpaymentAmount: number;
    custID: number;
}


export interface MinistryHoursRow {
  tripId: number;
  attendees: number;
  children: number;
  service: number;
  church: number;
  sports: number;
  prayer: number;
  school: number;
  mercy: number;
  evangelism: number;
  youth: number;
  adult: number;  
  medical: number;
  other: number;
}

export interface Ppm365SubscribeHistoryResponse {
  partnerId: string;
  partnerName: string;
  startDate: Date;
  endDate: Date | null;
  newuserId: number;
}

export interface OpsRegion {
  id: number;
  name: string
}

export interface ProfilesPartnerNeed {
  id: string;
  locId: string;
  comId: string;
  partnerId: string;
  oldId: number;
  oldlocId: number;
  oldcomId: number;
  oldpartnerId: number;
  date: Date | string | null;
  goaldate: Date | string | null;
  type: string | null;
  description: string | null;
  supplies: string | null;
  cost: number | null;
  completed: number;
  dateCompleted: Date | string | null;
  name: string | null;
  active: number;
  modified: Date | string | null;
  photo: number;
  monthly: number;
  featured: number;
}

export interface PartnerEvent {
  id: string;
  locId?: string;
  comId?: string;
  partnerId: string;
  oldId?: number;
  oldlocId?: number;
  oldcomId?: number;
  oldpartnerId?: number;
  dayofweek?: number;
  start?: string | null;
  end?: string | null;
  type?: string | null;
  description?: string | null;
  location?: string | null;
  name?: string | null;
  active?: number | null;
  modified?: string | null;
  photo?: number | null;
  webcast?: number | null;
  webcastUrl?: string | null;
  webcastPlatform?: string | null;
}